module.exports = __webpack_public_path__ + "img/home-cases-2.552493ca.png";